/**
 * Map Store API / network errors to customer-facing messages.
 */
import { getLabels } from '../config.js';

export function customerMessage(error, fallbackKey = 'genericError') {
	const labels = getLabels();
	const fallback = labels[fallbackKey] || labels.genericError || 'We could not add this item. Please try again or view the product page.';

	if (!error) {
		return fallback;
	}

	const code = String(error.code || error.errorCode || '').toLowerCase();
	const message = String(error.message || '');

	if (code.includes('nonce') || message.toLowerCase().includes('nonce')) {
		return labels.sessionExpired || fallback;
	}

	if (
		code.includes('out_of_stock') ||
		code.includes('stock') ||
		message.toLowerCase().includes('out of stock') ||
		message.toLowerCase().includes('not enough')
	) {
		return labels.stockChanged || fallback;
	}

	if (
		code.includes('sold_individually') ||
		code.includes('invalid_quantity') ||
		message.toLowerCase().includes('maximum')
	) {
		return labels.maxQuantity || fallback;
	}

	if (
		code.includes('not_purchasable') ||
		code.includes('invalid_product') ||
		message.toLowerCase().includes('purchasable')
	) {
		return labels.notPurchasable || fallback;
	}

	// Prefer short WooCommerce customer messages when present.
	if (message && message.length < 180 && !message.includes('Stack') && !message.includes('nonce')) {
		return message;
	}

	return fallback;
}

export function isNonceError(error) {
	if (!error) {
		return false;
	}
	const code = String(error.code || '').toLowerCase();
	const message = String(error.message || '').toLowerCase();
	return code.includes('nonce') || message.includes('nonce') || error.status === 401 || error.status === 403;
}
